import { State, Selector, Action, StateContext, Store } from '@ngxs/store';
import { Injectable } from '@angular/core';

export class UtmStateModel {
	utm?: any;
}

export class SetUtm {
	static readonly type = '[Utm] SetUtm';
	constructor(public utm: any) { }
}

@State<UtmStateModel>({
	name: 'utm'
})
@Injectable()
export class UtmState {
	constructor(private store: Store) { }

	@Selector()
	static utm(state: UtmStateModel) { return state.utm; }

	@Action(SetUtm)
	setUtm(context: StateContext<UtmStateModel>, payload: SetUtm) {
		// console.debug('setUtm', payload.utm);
		if (!payload.utm || payload.utm.utm_source == 'karpishe' || payload.utm.utm_source == 'karpishe.com') { return; }
		context.patchState({ utm: payload.utm });
	}
}
